import axiosInstance from '@/utils/api.js'

var state = {
  accountUSer: [],
  account_search: []
}

var getters = {
  ACCOUNT_USER: (state) => {
    return state.accountUSer
  },
  ACCOUNT_SEARCH: (state) => {
    return state.account_search
  }
}

var mutations = {
  SET_ACCOUNT_USER: (state, payload) => {
    state.accountUSer = payload
  },
  SET_ACCOUNT_SEARCH: (state, payload) => {
    state.account_search = payload
  }
}

var actions = {
  GET_ACCOUNT_USER: async (context, payload) => {
    let result = await axiosInstance.get('/users/accounts?user_id=' + payload)
    if (result.status === 200) {
      context.commit('SET_ACCOUNT_USER', result.data)
    }
  },
  CREATE_ACCOUNT: (context, payload) => {
    return axiosInstance.post('/users/accounts', payload)
  },
  CREATE_ACCOUNT_SEARCH: async (context, payload) => {
    let result = await axiosInstance.post('/users/accounts/search', payload)
    if (result.status === 200) {
      context.commit('SET_ACCOUNT_SEARCH', result.data)
    }
  },
  UPDATE_ACCOUNT: (context, payload) => {
    return axiosInstance.put('/users/accounts', payload)
  },
  DELETE_ACCOUNT: (context, payload) => {
    return axiosInstance.delete('/users/accounts?account_id=' + payload)
  },
  CHANGE_BALANCE: (context, payload) => {
    return axiosInstance.put('/users/change_account_balance', payload)
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/stores/users/accountsGroups.js